export default {
	'onboarding.addPhoto': 'Añada Foto',
	'onboarding.addManySkills': 'Great! You can add as many as <span class="skill-count">%{skillsLeft}</span> more %{skillsLeft} skill |||| %{skillsLeft} skills; the more the better [ES]',
	'onboarding.additionalSkills': 'Add additional skills to your profile to become eligible for more assignments [ES]',
	'onboarding.assignmentsNearYou': 'assignments available near you [ES]',
	'onboarding.atLeastOne': 'At least one industry must be chosen. [ES]',
	'onboarding.bankingInformation': 'Complete your banking information so you can withdraw your funds [ES]',
	'onboarding.companyOverviewLength': 'Company Overview must be 1000 characters or less. [ES]',
	'onboarding.completeTaxInformation': 'Complete your tax information so you can get get paid for assignments [ES]',
	'onboarding.done': '¡Listo!',
	'onboarding.dropPin': 'Please use the drop pin on the map to locate a valid street address. [ES]',
	'onboarding.expertise': 'Aptitud',
	'onboarding.firstNameLength': 'First Name must be 50 characters or less. [ES]',
	'onboarding.getDiscoveredByCompanies': 'Get discovered by companies and find the most relevant work by adding at least [ES]',
	'onboarding.industryCheckedBoolean': 'Industry checked needs to be a boolean. [ES]',
	'onboarding.industryIdNumber': 'Industry id needs to be a number. [ES]',
	'onboarding.industryIdNotNegative': 'Industry id cannot be negative. [ES]',
	'onboarding.industryName': 'Industry name needs to be a string. [ES]',
	'onboarding.industryKeyRequired': 'Industry %{key} is a required field. [ES]',
	'onboarding.lastNameLength': 'Last Name must be 50 characters or less. [ES]',
	'onboarding.location': 'Ubicación',
	'onboarding.profileInformation': 'Perfil',
	'onboarding.searchAndApplyForAssignments': 'Great! You are now ready to search and apply for assignments. [ES]',
	'onboarding.tips': 'A few tips before you get started: [ES]',
	'onboarding.updateSkillsLater': "Nice! You can always update your skills in the 'My Profile' section later. [ES]",
	'onboarding.validName': 'Cannot find a valid %{name}. [ES]',
	'onboarding.validEmailAddress': 'Please enter a valid email address [ES]',
	'onboarding.validPhoneNumber': 'Please enter a valid phone number. [ES]',
	'onboarding.validResponses': 'Please provide valid responses for all required fields. [ES]',
	'onboarding.validURI': 'Website is not a valid URI. [ES]',
	'onboarding.workExperience': 'Years of Work Experience [ES]'
};


// WEBPACK FOOTER //
// ./~/@workmarket/translation/dist-es/messages/es-es/onboarding.js